<template>
  <div>
    <a-drawer
      title="添加日志"
      :width="400"
      :visible="logVisible"
      @close="
        $emit('update:logVisible', false);
        form.resetFields();
      "
    >
      <a-form
        :form="form"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
        @submit="handleOk"
      >
        <a-form-item label="id" v-show="false">
          <a-input v-decorator="['id']"> </a-input>
        </a-form-item>
        <a-form-item label="站点名称">
          <a-select
            :disabled="false"
            v-decorator="[
              'station_id',
              {
                initialValue: '',
                rules: [{ required: true, message: '请选择站点名称' }]
              }
            ]"
            placeholder="请选择站点名称"
            option-filter-prop="children"
            showSearch
          >
            <a-select-option
              v-for="item in stationList"
              :key="item.station_id"
              :value="item.station_id"
            >
              {{ item.station_name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="运维人员">
          <a-select
            mode="multiple"
            v-decorator="[
              'ops_user_ids',
              {
                initialValue: [],
                rules: [{ required: true, message: '请选择运维人员' }]
              }
            ]"
            placeholder="请选择运维人员"
            option-filter-prop="children"
            showSearch
          >
            <a-select-option
              v-for="item in operationUserList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="上传图片">
          <a-upload
            v-decorator="[
              'pic_url',
              {
                rules: [{ required: true, message: '请上传图片' }],
                initialValue: fileList,
                valuePropName: 'pic_url',
                getValueFromEvent: normFile
              }
            ]"
            accept="image/*"
            :beforeUpload="beforeUploadFile"
            :customRequest="httpRequestFile"
            :remove="removeFile"
            list-type="picture-card"
            :file-list="fileList"
          >
            <div v-if="fileList.length < 1">
              <a-icon type="plus" />
              <div class="ant-upload-text">
                上传图片
              </div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item label="描述">
          <a-textarea
            v-decorator="[
              'comment',
              {
                rules: [{ required: true, message: '请输入描述' }]
              }
            ]"
            placeholder="请输入描述"
          />
        </a-form-item>
      </a-form>

      <div class="drawer-btn">
        <a-button
          :style="{ marginRight: '8px' }"
          @click="
            $emit('update:logVisible', false);
            form.resetFields();
          "
        >
          取消
        </a-button>
        <a-button type="primary" @click="handleOk">
          确定
        </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { addOperationTaskLog, ossUpload } from "@/api/api";
import { OSS_PIC_BASE_URL } from "@/config/config";

export default {
  data() {
    return {
      ossBaseUrl: OSS_PIC_BASE_URL,
      curData: [],
      form: this.$form.createForm(this),
      fileList: []
    };
  },
  props: {
    logVisible: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState(["authUserInfo", "stationList", "operationUserList"]),
    ...mapGetters(["defaultInfo"])
  },
  watch: {
    logVisible() {
      this.updateCurTask();
    }
  },
  methods: {
    async httpRequestFile(info) {
      let file = info.file;
      try {
        let fileName = await ossUpload(this.record.station_id, file);
        this.fileList = [
          {
            uid: file.uid,
            name: fileName,
            status: "done",
            url:
              this.ossBaseUrl +
              fileName +
              "?x-oss-process=image/resize,m_fill,w_100,h_100"
          }
        ];
      } catch (error) {
        console.log(error);
      }
    },
    beforeUploadFile(file, fileList) {
      const isImage = file.type.startsWith("image/");
      // const isImage = ['image/png', 'image/jpeg', 'image/jpg'].includes(file.type);
      if (!isImage) {
        this.$message.error("请上传图片文件！");
      }
      return isImage; // 返回 true 允许上传 false 禁止上传
    },
    removeFile(file) {
      return new Promise((resolve, reject) => {
        this.$confirm({
          title: "确认删除此图片?",
          okText: "确认",
          cancelText: "取消",
          onOk: () => {
            this.fileList = this.fileList.filter(x => x.name !== file.name);
            resolve();
          },
          onCancel: () => {
            this.$message.warning("取消删除");
            reject();
          }
        });
      });
    },
    normFile(e) {
      if (Array.isArray(e)) {
        return e;
      }
      if (e.file.status === "removed") {
        return [];
      }
      return e && e.fileList;
    },
    handleOk() {
      this.form.validateFields(async (err, values) => {
        if (err) return;
        const params = {
          ops_user_ids: values.ops_user_ids,
          station_id: values.station_id,
          task_type_id: values.task_type_id,
          comment: values.comment,
          task_id: values.id,
          pic_url: this.fileList[0].name
        };

        try {
          let res = await addOperationTaskLog(params);
          this.form.resetFields();
          this.$message.success(res.data.msg);
          this.$emit("onOk", false);
        } catch (error) {
          this.$emit("update:logVisible", false);
          console.log(error);
        }
      });
    },
    updateCurTask() {
      const editFields = ["id", "station_id", "ops_user_ids", "pic_url"];
      editFields.forEach(v => this.form.getFieldDecorator(v));
      const form_ = {};
      form_["id"] = this.record["id"];
      form_["station_id"] = this.record["station_id"];
      form_["ops_user_ids"] = this.record.ops_user.map(x => x.id);
      form_["pic_url"] = [];
      this.fileList = [];
      this.$nextTick(() => {
        this.form.setFieldsValue(form_);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.drawer-btn {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
/deep/ .ant-upload-list-picture-card .ant-upload-list-item {
  padding: 0;
}
</style>
